import http from 'utils/http';
import { getAgentActionsUrl, getAgentActionUrl } from './apiUrls';
import { AgentActionRequest, AgentActionResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getAgentActions(
  workspaceId: string,
  agentId: string,
  page: number
): Promise<{ data: AgentActionResponse[]; meta: MetaApiResponse }> {
  return http.get(getAgentActionsUrl(workspaceId, agentId), { page });
}

export function getAgentAction(workspaceId: string, agentId: string, actionId: string): Promise<AgentActionResponse> {
  return http.get(getAgentActionUrl(workspaceId, agentId, actionId));
}

export function createAgentAction(
  workspaceId: string,
  agentId: string,
  payload: AgentActionRequest
): Promise<AgentActionResponse> {
  return http.post(getAgentActionsUrl(workspaceId, agentId), payload);
}

export function updateAgentAction(
  workspaceId: string,
  agentId: string,
  id: string,
  payload: AgentActionRequest
): Promise<AgentActionResponse> {
  return http.put(getAgentActionUrl(workspaceId, agentId, id), payload);
}

export function deleteAgentAction(workspaceId: string, agentId: string, id: string): Promise<String> {
  return http.delete(getAgentActionUrl(workspaceId, agentId, id));
}
